import { useConfig } from '../context/ConfigProvider/ConfigProvider';
export const useGetBreakpointMediaQuery = (type) => {
    const { breakpoints } = useConfig();
    const getBreakpointMediaQueryValue = (breakpoint) => {
        const breakpointValue = breakpoints[breakpoint];
        return type === 'min' ? `calc(${breakpointValue} + 1px)` : breakpointValue;
    };
    const getBreakpointMediaQuery = (breakpoint) => {
        const breakpointValue = getBreakpointMediaQueryValue(breakpoint);
        return `@media screen and (${type}-width: ${breakpointValue})`;
    };
    return { getBreakpointMediaQuery, getBreakpointMediaQueryValue };
};
